import OpeningStatement from './opening-statement';
import Website from './website';
import SchoolType from './school-type';
import UndergraduateEnrollment from './undergraduate-enrollment';
import StudentFacultyRatio from './student-faculty-ratio';
import CampusSurroundings from './campus-surroundings';
import TestScores from './test-scores';
import GPA from './gpa';
import ContactInformation from './contact-information';
import withCollegeService from '../withCollegeService';

const OpeningStatementComponent = withCollegeService(
  OpeningStatement,
  'overview.openingStatement',
  '',
  {
    value: 'field_he_missionstatement',
  },
);

export const WebsiteComponent = withCollegeService(Website, 'overview.website', '', {
  value: 'field_url',
});

export const StudentFacultyRatioComponent = withCollegeService(StudentFacultyRatio, 'overview.studentFacultyRatio', '', {
  value: 'field_he_studentfacultyratio',
});

export const CampusSurroundingsComponent = withCollegeService(CampusSurroundings, 'overview.campusSurroundings.citySize', '', {
  value: 'field_he_city_size',
});

export const TestScoresComponent = withCollegeService(
  TestScores, 'overview.testScores',
  [],
  {
    25: 'field_he_low',
    50: 'field_he_average',
    75: 'field_he_high_score',
  },
  null,
  null,
  {
    type: 'he_undergraduate_admissions_us',
    field: 'field_he_test_us',
    fields: {
      field_he_testgroup_id: [{ value: '0' }],
    },
  },
);

export {
  OpeningStatementComponent as OpeningStatement,
  WebsiteComponent as Website,
  SchoolType,
  UndergraduateEnrollment,
  StudentFacultyRatioComponent as StudentFacultyRatio,
  CampusSurroundingsComponent as CampusSurroundings,
  TestScoresComponent as TestScores,
  GPA,
  ContactInformation,
};
